import React, { Fragment } from 'react';
import { Form } from 'react-bootstrap';

import Helmet from 'react-helmet';
import MainLP from '../../components/Layout/Main/Main';

// scss
import './ContactUs.scss';
function ContactUs() {
  return (
    <Fragment>
      <Helmet>
        <title>Home</title>
      </Helmet>
      <MainLP>
        <section className='headercontactus'>
          <div className='container'>
            <h6>
              Stay in touch with us <span className='ms-4 line'>----</span>
            </h6>
            <h3>CONTACT US</h3>
          </div>
        </section>
        <section className='contact-form'>
          <div className='container'>
            <h6>
              Send us a message <span className='ms-4 line'>----</span>
            </h6>
            <h2 className='mb-5'>CONTACT FORM</h2>

            <form>
              
              <div className='row mb-5'>
                <div className='col-lg-6'>
                  {' '}
                  <Form.Group>
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type='text'
                      placeholder='Enter Name Here'
                      className='shadow-lg inputText'
                    />
                  </Form.Group>
                </div>
                <div className='col-lg-6'>
                  <Form.Group>
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      type='text'
                      placeholder='Email Address'
                      className='shadow-lg inputText'
                    />
                  </Form.Group>
                </div>
              </div>
              <div>
                <Form.Group>
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as='textarea'
                    rows={8}
                    placeholder='Message'
                    className='shadow-lg'
                  />
                </Form.Group>
              </div>
              <button
                className='btn btn-primary mt-5'
                type='submit'
              >
                SEND
              </button>
            </form>
          </div>
        </section>
      </MainLP>
    </Fragment>
  );
}

export default ContactUs;
